import { SuggestionInputTable } from '@/ui/SuggestionInputTable'
import { FieldValues, useController, UseControllerProps, Path } from 'react-hook-form'
import styles from './TableFormDelayInput.module.scss'

const DELAY_OPTIONS = [
    {
        id: '5',
        label: '5 min',
        value: '5',
    },
    {
        id: '10',
        label: '10 min',
        value: '10',
    },
    {
        id: '15',
        label: '15 min',
        value: '15',
    },
    {
        id: '20',
        label: '20 min',
        value: '20',
    },
    {
        id: '25',
        label: '25 min',
        value: '25',
    },
    {
        id: '30',
        label: '30 min',
        value: '30',
    },
    {
        id: '35',
        label: '35 min',
        value: '35',
    },
    {
        id: '40',
        label: '40 min',
        value: '40',
    },
    {
        id: '45',
        label: '45 min',
        value: '45',
    },
    {
        id: '50',
        label: '50 min',
        value: '50',
    },
    {
        id: '55',
        label: '55 min',
        value: '55',
    },
]

interface Props<T extends FieldValues> extends Omit<UseControllerProps<T>, 'name'> {
    name: Path<T>
}

const MAX_LENGTH = 10

export const TableFormDelayInput = <T extends FieldValues>({ ...props }: Props<T>) => {
    const { field } = useController({ control: props.control, name: props.name })

    return (
        <SuggestionInputTable
            options={DELAY_OPTIONS}
            variant="table"
            transparent
            fullWidth
            className={styles.delaySuggestionMenu}
            inputClassName={styles.delayInput}
            placeholder="Delay"
            value={field.value}
            displayValueInsteadOfLabel
            maxLength={MAX_LENGTH}
            onChange={field.onChange}
        />
    )
}
